module.exports = __webpack_public_path__ + "media/v2/components/PrizesPage/shared/img/main_video@2x-ffd5d03983f99b5aa309e4b0e653e832.png";